export default __webpack_public_path__ + "static/media/0212-MMT-Alpha_4_2_228_L_inProcess.5d7ab1ad.jpg";